<script setup lang="ts">
import { LineModel } from '../../../core/line_model';
import { getApplicationInstance } from '../../../core/app';
import { useLineModel } from '../composables/app';
import { computed } from 'vue';

const props = defineProps<{ line: LineModel }>();
const line = computed(() => props.line);

const selectedLine = useLineModel();

const selected = computed(() => selectedLine.value === props.line);

const app = getApplicationInstance();
</script>

<template>
    <button @click="app.line = props.line" class="thumbnail-container" :class="{ 'thumbnail-selected': selected }">
        <img class="thumbnail" :src="line.thumbnail || '/thumbnails/default.png'" decoding="async" loading="lazy"></img>
        <p class="thumbnail-name">{{ line.name }}</p>
        <div class="thumbnail-description-container">
            <p v-if="line.grade" class="thumbnail-description grade"
                :style="{ '--grade-index': line.grade.index }">{{ line.grade.text }}</p>
        </div>
    </button>
</template>
